import { KbGuidePage } from "@/components/kb/KbGuidePage";

export function Guide002NvcNonviolentCommunication() {
  return <KbGuidePage slug="guide-002-nvc-nonviolent-communication" />;
}

(Guide002NvcNonviolentCommunication as unknown as { path: string }).path = "/guides/nvc-nonviolent-communication";
